import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuItem, SelectItem, ToastMessageOptions } from 'primeng/api';

import { combineLatest, map, Subscription } from 'rxjs';
import { fromFormControl, MessageService } from 'shared';

@Component({
    selector: 'app-home',
    templateUrl: './style-guide.component.html',
    styleUrls: ['./style-guide.component.scss'],
    standalone: false
})
export class StyleGuideComponent implements OnInit, OnDestroy {
    currentTab: string = 'tab1';

    stepItems: MenuItem[] = [
        { label: 'Steps are' },
        { label: 'useful in' },
        { label: 'specific situations.' }
    ];

    buttonTableData = [
        { buttonType: 'Primary', usage: 'Actions, confirmation', severity: 'primary', cssClass: '(none)', icon: 'pi pi-pencil' },
        { buttonType: 'Secondary', usage: 'cancel performing an action or uncommon alternatives', severity: 'secondary', cssClass: 'p-button-secondary', icon: '', onlyIcon: 'pi pi-ban' },
        { buttonType: 'Info', usage: 'showing more information', severity: 'info', cssClass: 'p-button-info', icon: 'pi pi-info-circle' },
        { buttonType: 'Success', usage: 'creation', severity: 'success', cssClass: 'p-button-success', icon: 'pi pi-plus' },
        { buttonType: 'Warn', usage: 'actions which result in "soft-delete"-type states', severity: 'warn', cssClass: 'p-button-warn', icon: 'pi pi-exclamation-triangle' },
        { buttonType: 'Danger', usage: 'actions that are "dangerous", e.g. deletions', severity: 'danger', cssClass: 'p-button-danger', icon: 'pi pi-trash' }
    ];

    requiredField = new FormControl<string>('', Validators.required);
    radioGroup = new FormControl<string>('Option 1');

    selectOptions: SelectItem<string>[] = [
        { label: 'Option 1', value: 'option1' },
        { label: 'Option 2', value: 'option2' },
        { label: 'Option 3', value: 'option3' }
    ];

    tabledata = [
        { col1: 'Row 1', col2: 'qwerqwer', col3: '123' },
        { col1: 'Row 2', col2: 'asdfasdf', col3: '678' },
    ];

    tablesearch = new FormControl<string>('');

    tablecolfilters = new FormGroup({
        col1: new FormControl<string>(''),
        col2: new FormControl<string>(''),
        col3: new FormControl<string>(''),
    })

    tabledatafiltered = combineLatest([
        fromFormControl(this.tablesearch),
        fromFormControl(this.tablecolfilters)
    ]).pipe(
        map(([search, colFilters]) => this.tabledata.filter(row =>
            (!search || row.col1.includes(search) || row.col2.includes(search) || row.col3.includes(search))
            && (!colFilters.col1 || row.col1.includes(colFilters.col1))
            && (!colFilters.col2 || row.col2.includes(colFilters.col2))
            && (!colFilters.col3 || row.col3.includes(colFilters.col3))
        ))
    );

    private subscriptions: Subscription[] = [];

    constructor(private messageService: MessageService) { }

    ngOnInit() {
        this.subscriptions = [];

        this.requiredField.markAsTouched();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    showToast(severity?: string) {
        const message: ToastMessageOptions = {
            severity: severity,
            summary: 'Message Title',
            detail: 'Message Content'
        };

        if (severity === 'success')
            message.data = { list: ['List Item 1', 'List Item 2', 'List Item 3'] };

        if (severity === 'warn')
            message.data = { text: 'Additional information about the warning.' };

        if (severity === 'error')
            message.data = { button: { label: 'Retry', action: () => { alert('Retrying...'); } } };

        this.messageService.add(message);
    }
}
